import axios from "axios";

import { AccountResponse, ConnectedPlatforms } from "0.Mine/3.Interfaces/accountResponse";
import { DirectMessages, DMResponse } from "0.Mine/3.Interfaces/DMResponse";
import { GMBReviewResponse, Inbox } from "0.Mine/3.Interfaces/GMBReview";
import { Post } from "0.Mine/3.Interfaces/PostResponse";

import { AdditionalParams, QlickupActions, useQlickupAPI } from "../APICall";

export const UseMetricool = () => {
  const { QlickUpAPI, QlickUpAPIWithFormData } = useQlickupAPI();

  const getConnectionLink = async (businessId: number) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "isConnected",
        null,
        "mc_social",
        QlickupActions.GET
      );

      if (response.success && response.status === "connected") {
        return response.whiteLabelLink as string;
      }

      return null;
    } catch (error) {
      console.error("Error fetching connection link:", error);
      return null;
    }
  };

  const getallMetricsAndPosts = async (businessId: number) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "getAllMetrics",
        null,
        "mc_social",
        QlickupActions.GET
      );
      console.log("RESPONSE METRIC", response);
      if (response) {
        console.log(response.data);
        return response.summary.data as Post[];
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error fetching metricool data:", error);
      return null;
    }
  };

  const getConnectedSocials = async (businessId: number) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "getSocials",
        null,
        "mc_social",
        QlickupActions.GET
      );

      // Check if response exists and has the expected structure
      if (!response) {
        return null;
      }

      // Check if response has platforms property
      if (!response.platforms) {
        return null;
      }

      // Check if platforms has connected property
      if (!response.platforms.connected) {
        return [];
      }

      return response.platforms.connected as ConnectedPlatforms[];
    } catch (error) {
      return null;
    }
  };

  //TO ADD: LOCATION, HASHTAGS
  const postOnSocial = async (
    businessId: number,
    content: string,
    platforms: string[],
    images?: File[],
    schedule_time?: Date,
    imagePaths?: string[]
  ) => {
    // Create FormData object
    const formData = new FormData();
    formData.append("text", content);
    formData.append("businessId", businessId.toString());
    formData.append("media_urls", JSON.stringify(imagePaths || []));
    platforms.forEach((platform) => {
      formData.append("platforms", platform.toLowerCase());
    });

    // Add schedule time if provided, ensuring it's in the future and using local timezone
    if (schedule_time) {
      const now = new Date();

      // Check if schedule_time is in the past
      if (schedule_time.getTime() <= now.getTime()) {
        // Add 30 seconds to current time to ensure it's in the future
        const futureTime = new Date(now.getTime() + 0.5 * 60 * 1000);
        const localTimeString = formatDateToLocalISOString(futureTime);
        formData.append("schedule_time", localTimeString);
      } else {
        const localTimeString = formatDateToLocalISOString(schedule_time);
        formData.append("schedule_time", localTimeString);
      }
    }

    // Add media files if provided
    if (images && images.length > 0) {
      images.forEach((file, index) => {
        formData.append(`media[${index}]`, file);
      });
    }

    const response = await QlickUpAPIWithFormData(
      businessId.toString(),
      "postNow",
      null,
      "metricool",
      QlickupActions.POST,
      formData
    );

    return response;
  };

  const getGMBReviews = async (businessId: number) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "getinbox",
        null,
        "mc_social",
        QlickupActions.GET
      );
      console.log("RESPONSE GMB REVIEWS", response);

      if (response.success) {
        return response.inbox as Inbox;
      } else {
        console.error("Error fetching GMB reviews:", response.error);
        return null;
      }
    } catch (error) {
      console.error("Error fetching GMB reviews:", error);
      return null;
    }
  };

  const getDM = async (businessId: number) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "getDM",
        null,
        "mc_social",
        QlickupActions.GET
      );

      console.log("RESPONSE GMB REVIEWS", response);
      if (response.success) {
        return response.directMessages as DirectMessages;
      } else {
        console.error("Error fetching GMB reviews:", response.error);
        return null;
      }
    } catch (error) {
      console.error("Error fetching GMB reviews:", error);
      return null;
    }
  };

  function formatDateToLocalISOString(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  return {
    postOnSocial,
    getallMetricsAndPosts,
    getConnectedSocials,
    getGMBReviews,
    getConnectionLink,
    getDM,
  };
};
